import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/commerce/quotes/new")({
	component: () => (
		<Navigate to="/commerce/quotes" search={{ create: true }} replace />
	),
});
